module.exports = __webpack_public_path__ + "img/canstar.0c672243.png";